import { useEffect,useRef } from "react";

export const useRefHook = (data) => {

    const refData=useRef(null)

  useEffect(() => {
    refData.current=data
    return()=>{
        refData.current=null
    }
  }, [data]);

  return refData
};
